<template>
  <v-data-table
      v-model="selectedItems"
      :headers="headers"
      :items="items"
      :server-items-length="total"
      :options.sync="options"
      :loading="loading"
      :footer-props="{ itemsPerPageOptions: [10, 20, 50, 100] }"
      :show-select="allowSelectItems"
      :mobile-breakpoint="0"
      class="elevation-12"
      dense
  >
    <template v-slot:top>
      <div class="px-4">
        <v-row>
          <v-col cols="12" sm="6" md="4" lg="3">
            <v-select v-model="filters.region"
                      :items="$store.getters.appLogin.regions"
                      :item-value="item => item"
                      :item-text="item => item.name"
                      label="Область"
                      :clearable="true"
                      :error-messages="validationErrorMessages.region()"
                      @change="onFiltersChanged"
            />
          </v-col>
          <v-col cols="12" sm="6" md="4" lg="3">
            <v-autocomplete v-model="filters.area"
                            :items="sortedAreas"
                            :item-value="item => item"
                            :item-text="item => item.name"
                            :error-messages="validationErrorMessages.area()"
                            label="Район"
                            :clearable="true"
                            @change="onFiltersChanged"
            />
          </v-col>
          <v-col cols="12" sm="6" md="4" lg="3">
            <v-menu
                v-model="filterStartMenu"
                transition="scale-transition"
                offset-y
                :nudge-right="40"
                max-width="290px"
                min-width="290px"
                :close-on-content-click="false"
            >
              <template v-slot:activator="{on}">
                <v-text-field
                    label="Начало даты поступления"
                    v-model="filterStartDisplayValue"
                    readonly
                    v-on="on"
                    :clearable="false"
                    @input="onChangeFilterStartDisplayValue"
                />
              </template>
              <v-date-picker
                  v-model="filters.start"
                  @change="onFilterStartChanged"
                  no-title
                  scrollable
                  locale="ru"
                  first-day-of-week="1"
              />
            </v-menu>
          </v-col>
          <v-col cols="12" sm="6" md="4" lg="3">
            <v-menu
                v-model="filterEndMenu"
                transition="scale-transition"
                offset-y
                :nudge-right="40"
                max-width="290px"
                min-width="290px"
                :close-on-content-click="false"
            >
              <template v-slot:activator="{on}">
                <v-text-field
                    label="Конец даты поступления"
                    v-model="filterEndDisplayValue"
                    readonly
                    v-on="on"
                    :clearable="false"
                    @input="onChangeFilterEndDisplayValue"
                />
              </template>
              <v-date-picker
                  v-model="filters.end"
                  @change="onFilterEndChanged"
                  no-title
                  scrollable
                  locale="ru"
                  first-day-of-week="1"
              />
            </v-menu>
          </v-col>
          <v-col cols="12" sm="6" md="4" lg="3">
            <v-select v-model="filters.isDistributed"
                      :items="isDistributedFilterOptions"
                      label="Распределено?"
                      @change="onFiltersChanged"
            />
          </v-col>
          <v-col cols="12" sm="6" md="4" lg="3">
            <v-select v-model="filters.isPrinted"
                      :items="isPrintedFilterOptions"
                      label="Распечатано?"
                      @change="onFiltersChanged"
            />
          </v-col>
          <v-col cols="12" sm="6" md="4" lg="3">
            <v-select v-model="filters.isPosted"
                      :items="isPostedFilterOptions"
                      label="Пост пакетировано?"
                      @change="onFiltersChanged"
            />
          </v-col>
          <v-col cols="12" sm="6" md="4" lg="3">
            <v-select v-model="filters.isPerformed"
                      :items="isPerformedFilterOptions"
                      label="Результат установлен?"
                      @change="onFiltersChanged"
            />
          </v-col>
          <v-col cols="12" sm="6" md="4" lg="3">
            <v-select v-model="filters.isTransferNotified"
                      :items="isTransferNotifiedFilterOptions"
                      label="Передача информирована в Шипокс?"
                      @change="onFiltersChanged"
            />
          </v-col>
          <v-col cols="12" sm="6" md="4" lg="3">
            <v-select v-model="filters.isTransferCompleted"
                      :items="isTransferCompletedFilterOptions"
                      label="Передача завершена?"
                      @change="onFiltersChanged"
            />
          </v-col>
          <v-col cols="12" sm="6" md="4" lg="3" v-if="allowIsExpressFilter">
            <v-select v-model="filters.isExpress"
                      :items="isExpressFilterOptions"
                      label="Срочное?"
                      @change="onFiltersChanged"
            />
          </v-col>
          <v-col cols="12" sm="6" md="4" lg="3">
            <v-autocomplete v-model="filters.postIndex"
                            :items="sortedPostIndexes"
                            :item-value="item => item.postCode"
                            :item-text="item => `${item.postCode} - ${item.name}`"
                            label="Пост индекс"
                            :clearable="true"
                            @change="onFiltersChanged"
            />
          </v-col>
          <v-col cols="12" sm="6" md="3" lg="3">
            <v-select v-model="filters.performTypes"
                      :items="performTypeOptions"
                      :clearable="true"
                      label="Статус"
                      multiple
            >
              <template v-slot:selection="{ item, index }">
                <v-chip v-if="index < 2" small style="background-color: #111; color: white; ">
                  <span>{{ item.text }}</span>
                </v-chip>
                <span
                    v-if="index === 2"
                    class="text-grey text-caption align-self-center"
                >
          (+{{ filters.performTypes.length - 2 }} другие)
          </span>
              </template>
            </v-select>
          </v-col>

          <div v-if="allowSelect"  class="col-12 d-block d-md-flex align-center flex-md-row flex-column">
            <v-col cols="12" md="6" class="d-flex align-center justify-center justify-md-start">
              <v-checkbox v-if="allowOperations"
                          :input-value="allowSelectItems"
                          @change="toggleAllowSelectItems($event)"
                          label="Показать выбор"
                          class="d-inline-block me-2"
              />
              <v-btn color="primary"
                     @click="onAddPostIndexClicked"
                     max-width="220px"
                     class="me-2"
                     v-if="selectedItems.length > 0 && allowAddingPostIndex"
              >
                Добавить пост-индекс
              </v-btn>
              <v-btn color="success"
                     max-width="220px"
                     @click="showSuccessPerformModal = true"
                     class="me-2"
                     v-if="selectedItems.length > 0 && ($store.getters.appLogin.id === 11 || $store.getters.appLogin.id === 10)"
              >
                Вручено(Топширилди)
              </v-btn>
              <v-btn color="error"
                     max-width="220px"
                     class="me-2"
                     @click="showFailedDeliveryModal = true"
                     v-if="selectedItems.length > 0 && ($store.getters.appLogin.id === 11 || $store.getters.appLogin.id === 10)"
              >
                Возврат(Қайтариш)
              </v-btn>
            </v-col>

            <v-col cols="12" md="6" class="d-flex align-center justify-center justify-md-end">
              <v-btn :disabled="isAllowedReload()" x-large color="primary" class="me-2" dark @click="onRefreshButtonClicked">Обновить</v-btn>
              <v-btn v-if="allowCreatePrintPackage"
                     x-large
                     color="success"
                     @click="onCreatePrintPackageClicked">
                Новая печать
              </v-btn>
            </v-col>
          </div>
          <div v-else class="col-12 d-block d-md-flex laign-center flex-md-row flex-column">
            <v-col cols="12" md="12" class="d-flex align-center justify-center justify-md-end">
              <v-btn :disabled="isAllowedReload()" x-large color="primary" class="me-2" dark @click="onRefreshButtonClicked">Обновить</v-btn>
              <v-btn v-if="allowCreatePrintPackage"
                     x-large
                     color="success"
                     @click="onCreatePrintPackageClicked">
                Новая печать
              </v-btn>
            </v-col>
          </div>
          <v-dialog v-model="showModal" :persistent="true" width="600px">
            <PostIndexModalComponent ref="postIndexModal" @close-modal="closeModal" @send-records="receiveRecords"/>
          </v-dialog>
          <v-dialog v-model="showSuccessPerformModal" :persistent="true" width="600px">
            <SuccessDeliveredPerformMails :pfilters="filters" :mails="selectedItems" @close-modal="closeSuccessPerformModal"  ref="successDeliveredPerformMails"/>
          </v-dialog>
          <v-dialog v-model="showFailedDeliveryModal" :persistent="true" width="600px">
            <FailedDeliveryPerformMails @close-modal="closeFailedDeliveryModal" :pfilters="filters" :mails="selectedItems" ref="failedDeliveredPerformMails"/>
          </v-dialog>
        </v-row>
        <v-snackbar
            v-if="isAllowedReload()"
            :timeout="-1"
            :value="true"
            absolute
            bottom
            color="red"
            right
        >
          Дату можно выбрать в пределах одного месяца
        </v-snackbar>
      </div>
    </template>
    <template v-slot:item="{item, index, isSelected, select}">
      <tr :class="{
                    'white--text black': item.isPerformedNotTry,
                    'white--text warning darken-1': item.isPerformedTry,
                    'green lighten-4': !item.isPerformedTry && !item.isPerformedNotTry && item.isPacked,
                    'light-blue lighten-4': !item.isPerformedTry && !item.isPerformedNotTry && !item.isPacked && item.isPrinted,
                    'yellow lighten-1': !item.isPerformedTry && !item.isPerformedNotTry && !item.isPacked && !item.isPrinted && item.isTransferNotified,
                    }">
        <td v-if="allowSelectItems">
          <v-simple-checkbox :value="isSelected" :disabled="item.isPostIndexed && item.isPerformedNotTry" @input="select($event)"></v-simple-checkbox>
        </td>
        <td class="text-center pa-1">{{ index + 1 }}</td>
        <td class="text-left pa-1">
          <router-link :to="{name: 'mail', params:{uid: item.uid}}">
            {{ item.uid }}
          </router-link>
          <span v-if="item.isExpress" class="white--text red">Срочно</span>
        </td>
        <td class="pa-1">{{ item.receiver }}</td>
        <td class="pa-1">{{ item.region.name }}</td>
        <td class="pa-1">{{ item.area.name }}</td>
        <td class="pa-1">{{ item.address }}</td>
        <td class="text-center pa-1" style="width: 11%;" @dblclick="onEditPostIndex(index, item)">
          <template v-if="editingIndex === index">
            <v-text-field v-model="postIndex"
                          style="background-color:aliceblue;"
                          filled
                          autofocus
                          dense
                          outlined
                          clearable
                          label="Пост индекс"
                          hint="100001"
                          append-icon="mdi-check"
                          @click:append="updatePostIndex(index)"
                          :error-messages="validationErrorMessages.postIndex()"
            />
          </template>
          <template v-else>
            {{item.postIndex && item.postIndex.postCode}}
          </template>
        </td>
        <td class="text-center pa-1" style="width: 110px">
          <template v-if="item.perform">
            {{ item.perform.performType.name }}
          </template>
          <template v-else>
            Статус неустановлен
          </template>
        </td>
        <td class="text-center pa-1" style="width: 110px">
          {{ item.createdOn.format('DD.MM.YYYY') }}
          <br>
          {{ item.createdOn.format('HH:mm:ss') }}
        </td>
        <td class="text-center pa-1" style="width: 90px">
          <template v-if="item.perform">
            {{ item.perform.performedOn.format('DD.MM.YYYY') }}
          </template>
          <template v-else>
            <v-icon>mdi-calendar-remove</v-icon>
          </template>
        </td>
        <td class="text-center pa-1" style="width: 90px">
          <template v-if="item.perform">
            {{ item.perform.createdOn.format('DD.MM.YYYY') }}
            <br>
            {{ item.perform.createdOn.format('HH:mm:ss') }}
          </template>
          <template v-else>
            <v-icon>mdi-calendar-remove</v-icon>
          </template>
        </td>
        <td class="text-center pa-1" style="width: 110px">
          <template v-if="item.printPackage">
            <router-link :to="{name: 'print-package', params: {uid: item.printPackage.uid}}">{{
                item.printPackage.uid
              }}
            </router-link>
          </template>
        </td>
        <td class="text-center pa-1" style="width: 110px">
          <template v-if="item.postPackage">
            <router-link :to="{name: 'post-package', params: {uid: item.postPackage.uid}}">{{
                item.postPackage.uid
              }}
            </router-link>
          </template>
        </td>
      </tr>
    </template>
    <template v-slot:no-data>
      Писем не найдено
    </template>
    <v-card-text v-if="loading">
      Loading...
      <v-btn color="error">Cancel</v-btn>
    </v-card-text>
  </v-data-table>
</template>
<script>
import _ from 'underscore'
import Moment from 'moment'
import {DXA} from "@/enums/client";
import {required, requiredIf} from 'vuelidate/lib/validators'
import {LAYOUT_LOADING_START, LAYOUT_LOADING_STOP} from "@/store/modules/layout/actions";
import converter from "@/helpers/converter";
import PostIndexService from "@/services/post.index.service";
import $store from "@/store"
import {MailPostIndexClients, MailPostIndexRegions} from "@/helpers/constants";
import PostIndexModalComponent from "@/components/PostIndexModalComponent.vue";
import {DateLimitForFilters} from "@/settings/server";
import SuccessDeliveredPerformMails from "@/components/mail/perform/SuccessDeliveredPerformMails.vue";
import FailedDeliveryPerformMails from "@/components/mail/perform/FailedDeliveryPerformMails.vue";
export default {
  components: {
    FailedDeliveryPerformMails,
    SuccessDeliveredPerformMails,
    PostIndexModalComponent,
  },
  name: "PrintMailDataTable",
  props: {
    mails: {
      type: Array,
      default: () => {
        return [];
      }
    },
    total: {
      type: Number,
      default: 0
    },
    loading: {
      type: Boolean,
      default: false
    },
    allowCreatePrintPackage: {
      type: Boolean,
      default: false
    },
    allowOperations: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      options: {
        //todo complete handling options in route query
        // sortBy: ['createdOn'],
        // sortDesc: [true],
        // page: 1,
        // itemsPerPage: 50,
        // sortBy: this.$route.query && this.$route.query.sortBy ?  [this.$route.query.sortBy] : ['createdOn'],
        // sortDesc: this.$route.query && this.$route.query.sortDesc ? [this.$route.query.sortDesc] : [true],
        // page: this.$route.query && this.$route.query.page ? +this.$route.query.page : 1,
        // itemsPerPage: this.$route.query && this.$route.query.itemsPerPage ? +this.$route.query.itemsPerPage : 50,
        sortBy: ['createdOn'],
        sortDesc: [true],
        page: 1,
        itemsPerPage: 50,
      },
      filters: {
        region: this.$store.getters.appLogin.regions[0],
        area: this.$store.getters.appLogin.areas.filter(area => area.region.id === this.$store.getters.appLogin.regions[0].id)[0],
        start: null,
        end: null,
        isDistributed: null,
        isPrinted: false,
        isPosted: false,
        isPerformed: false,
        isTransferNotified: null,
        isTransferCompleted: null,
        postIndex: null,
        isExpress: null,
        performTypes: []
      },
      performTypeOptions: [
        { text: 'Доставлен', value: 0 },
        { text: 'Адресат умер', value: 1 },
        { text: 'Адресат по указанному адресу не проживает', value: 2 },
        { text: 'Указан не полный адрес', value: 3 },
        { text: 'Адресат от получения отказался', value: 4 },
        { text: 'Нет дома', value: 5 },
        { text: 'Не явился по извещению', value: 6 },
        { text: 'Адрес не определен', value: 7 },
        { text: 'Попытка вручения', value: 8 },
        { text: 'По указанному адресу организация не найдена', value: 9 }
      ],
      editingIndex: null,
      postIndex: '',
      postIndexErrorMessage: '',
      allowSelectItems: false,
      itemsToggled: false,
      selectedItems: [],
      filterStartMenu: false,
      filterEndMenu: false,
      filterStartDisplayValue: '',
      filterEndDisplayValue: '',
      showModal: false,
      showSuccessPerformModal: false,
      showFailedDeliveryModal: false,
    };
  },
  computed: {
    items() {
      return _.map(this.mails, m => {
        return m
      })
    },
    sortedPostIndexes(){
      var selectedRegionId = this.filters.region?.id
      var selectedAreaId = this.filters.area?.id
      if(selectedRegionId > 0){
        if(selectedAreaId > 0){
          return $store.getters.appPostIndexes.filter(
              item => item.postRegionCode === selectedRegionId &&
                  item.postDistrictCode === selectedAreaId);
        }
        return $store.getters.appPostIndexes.filter(item => item.postRegionCode === selectedRegionId)
      }
      else{
        return $store.getters.appPostIndexes;
      }
    },
    sortedAreas(){
      var selectedRegionId = this.filters.region?.id;
      if(selectedRegionId > 0){
        return $store.getters.appLogin.areas.filter(item => item.region?.id === selectedRegionId)
      }
      else{
        return $store.getters.appLogin.areas;
      }
    }
    ,
    headers() {
      const headers = [];
      headers.push({
        text: '№',
        align: 'center',
        sortable: false,
        value: 'displayNumber'
      })
      headers.push({
        text: 'Идентификатор',
        align: 'left',
        sortable: false,
        value: 'uid'
      })
      headers.push({
        text: 'Получатель',
        align: 'left',
        sortable: false,
        value: 'receiver'
      })
      headers.push({
        text: 'Область',
        align: 'center',
        sortable: false,
        value: 'region'
      })
      headers.push({
        text: 'Район',
        align: 'center',
        sortable: false,
        value: 'area'
      })
      headers.push({
        text: 'Адрес',
        align: 'left',
        sortable: false,
        value: 'address'
      })
      headers.push({
        text: 'Пост индекс',
        align: 'center',
        sortable: false,
        value: 'postIndex'
      })
      headers.push({
        text: 'Состояние',
        align: 'left',
        sortable: false,
        value: 'perform.performType.name'
      })
      headers.push({
        text: 'Дата поступления',
        align: 'center',
        sortable: true,
        value: 'createdOn'
      })
      headers.push({
        text: 'Дата вручения',
        align: 'center',
        sortable: false,
        value: 'perform.createdOn'
      })
      headers.push({
        text: 'Дата ввода информации',
        align: 'center',
        sortable: false,
        value: 'postPackage.createdOn'
      })
      headers.push({
        text: 'Печатный пакет',
        align: 'center',
        sortable: false,
        value: 'printPackage'
      })
      headers.push({
        text: 'Пост пакет',
        align: 'center',
        sortable: false,
        value: 'postPackage'
      })
      return headers;
    },
    skip() {
      return (this.options.page - 1) * this.options.itemsPerPage
    },
    validationErrorMessages(vm) {
      return {
        region() {
          const errors = [];
          if (vm.$v.filters.$dirty) {
            !vm.$v.filters.region.required && errors.push('Выберите область');
          }
          return errors;
        },
        area() {
          const errors = [];
          if (vm.$v.filters.$dirty) {
            !vm.$v.filters.area.required && errors.push('Выберите район');
          }
          return errors;
        },
        postIndex() {
          const errors = [];

          // Check if vm.$v is defined and has postIndex property
          if (vm.$v && vm.$v.postIndex) {
            if (vm.postIndexErrorMessage) {
              errors.push('Введён неправильный пост-индекс');
            }

            // Check if vm.$v.postIndex.$dirty is defined before accessing it
            if (vm.$v.postIndex.$dirty) {
              // Validation rules...
              if (!vm.$v.postIndex.required) {
                errors.push('Это поле обязательно для заполнения!');
              }
              if (!vm.$v.postIndex.regExp) {
                errors.push('Неправильный формат! Только цифры');
              }
              if (!vm.$v.postIndex.minLength) {
                errors.push('Минимум 6 символов');
              }
              if (!vm.$v.postIndex.maxLength) {
                errors.push('Максимум 6 символов');
              }
            }
          }
          return errors;
        }
      }
    },
    isDistributedFilterOptions() {
      return [
        {text: 'Да', value: true},
        {text: 'Нет', value: false},
        {text: 'Неважно', value: null},
      ];
    },
    isPrintedFilterOptions() {
      return [
        {text: 'Да', value: true},
        {text: 'Нет', value: false},
        {text: 'Неважно', value: null}
      ];
    },
    isPostedFilterOptions() {
      return [
        {text: 'Да', value: true},
        {text: 'Нет', value: false},
        {text: 'Неважно', value: null}
      ];
    },
    isPerformedFilterOptions() {
      return [
        {text: 'Да', value: true},
        {text: 'Нет', value: false},
        {text: 'Неважно', value: null}
      ];
    },
    isTransferNotifiedFilterOptions() {
      return [
        {text: 'Да', value: true},
        {text: 'Нет', value: false},
        {text: 'Неважно', value: null}
      ];
    },
    isTransferCompletedFilterOptions() {
      return [
        {text: 'Да', value: true},
        {text: 'Нет', value: false},
        {text: 'Неважно', value: null}
      ];
    },
    isExpressFilterOptions() {
      return [
        {text: 'Да', value: true},
        {text: 'Нет', value: false},
        {text: 'Неважно', value: null}
      ];
    },
    allowIsExpressFilter() {
      return this.$store.getters.appActiveClient === DXA;
    },
    allowAddingPostIndex() {
      return MailPostIndexClients.includes(this.$store.getters.appActiveClient) && MailPostIndexRegions.includes(this.filters.region?.id);
    },
    allowSelect() {
      if($store.getters.appLogin.id === 11 || $store.getters.appLogin.id === 10){
        return true;
      }
      return MailPostIndexClients.includes(this.$store.getters.appActiveClient) && MailPostIndexRegions.includes(this.filters.region?.id);
    },
    toggledItems() {
      return this.itemsToggled
    }
  },
  validations: {
    filters: {
      region: {
        required,
      },
      area: {
        required: requiredIf(function () {
          return this.toggledItems
        })
      }
    },
  },
  methods: {
    isAllowedReload() {
      const startDate = this.filters.start;
      const endDate = this.filters.end;
      if (startDate && endDate) {
        const start = new Date(startDate);
        const end = new Date(endDate);
        const dayDifference = (end - start) / (1000 * 60 * 60 * 24);
        if (dayDifference > DateLimitForFilters) {
          return true;
        }
      }
      return false
    },
    receiveRecords(mailUids) {
      this.$emit('create-print-package-after-postindex', this.options, this.filters, mailUids);
    },
    closeModal() {
      this.showModal = false;
    },
    closeSuccessPerformModal() {
      this.showSuccessPerformModal = false;
      this.onRefreshButtonClicked()
    },
    closeFailedDeliveryModal() {
      this.showFailedDeliveryModal = false;
      this.onRefreshButtonClicked()
    },
    updateItems() {
      if(!this.isAllowedReload()){
        this.$emit("update", this.options, this.filters)
        this.updateRouteQuery(this.options, this.filters)
      }
    },
    updateRouteQuery(options, filters) {
      const {sortBy, sortDesc, page, itemsPerPage} = options;
      const {region, area, isDistributed, isPrinted, isPosted, isPerformed, isTransferNotified, isTransferCompleted, isExpress, start, end, postIndex} = filters;
      let routeQuery = {}
      // options
      if (!sortBy) {
        this.options.sortBy = ['createdOn']
      }
      if (!sortDesc) {
        this.options.sortDesc = [true]
      }
      if (!page) {
        this.options.page = 1
      }
      if (!itemsPerPage) {
        this.options.itemsPerPage = 50
      }
      routeQuery.sortBy = sortBy?.length === 1 ? sortBy[0] : sortBy
      routeQuery.sortDesc = sortDesc?.length === 1 ? sortDesc[0] : sortDesc
      routeQuery.page = page ?? page
      routeQuery.itemsPerPage = itemsPerPage ?? itemsPerPage
      // filters
      if (region) {
        routeQuery.region = region._id
      }
      if (area) {
        routeQuery.area = area._id
      }
      if (isDistributed != null) {
        routeQuery.isDistributed = isDistributed
      }
      if (isPrinted != null) {
        routeQuery.isPrinted = isPrinted
      }
      if (isPosted != null) {
        routeQuery.isPosted = isPosted
      }
      if (isPerformed != null) {
        routeQuery.isPerformed = isPerformed
      }
      if (isTransferNotified != null) {
        routeQuery.isTransferNotified = isTransferNotified
      }
      if (isTransferCompleted != null) {
        routeQuery.isTransferCompleted = isTransferCompleted
      }
      if (isExpress != null) {
        routeQuery.isExpress = isExpress
      }
      if (start != null) {
        routeQuery.start = start
      }
      if (end != null) {
        routeQuery.end = end
      }
      if (postIndex) {
        routeQuery.postIndex = postIndex
      }
      this.$router.push({name: this.$route.name, query: routeQuery}).catch(error => { console.log(error) })
    },
    createPrintPackage() {
      this.$emit('create-print-package', this.options, this.filters)
    },
    onFiltersChanged() {
      let vm = this;
      vm.selectedItems = [];
      if (vm.options.page !== 1)
        vm.options.page = 1;
      else
        vm.updateItems();
    },
    onRefreshButtonClicked() {
      this.updateItems();
    },
    onFilterStartChanged() {
      if (this.filters.start) {
        this.filterStartDisplayValue = Moment(this.filters.start, 'YYYY-MM-DD').format('DD.MM.YYYY')
      } else {
        this.filterStartDisplayValue = ''
      }
      this.filterStartMenu = false
      if (this.filters.start && this.filters.end) {
        const start = new Date(this.filters.start);
        const end = new Date( this.filters.end);
        const dayDifference = (end - start) / (1000 * 60 * 60 * 24);
        if (dayDifference <= DateLimitForFilters) {
          this.updateItems()
        }
      }
    },
    onFilterEndChanged() {
      if (this.filters.end) {
        this.filterEndDisplayValue = Moment(this.filters.end, 'YYYY-MM-DD').format('DD.MM.YYYY')
      } else {
        this.filterEndDisplayValue = ''
      }
      this.filterEndMenu = false
      if (this.filters.start && this.filters.end) {
        const start = new Date(this.filters.start);
        const end = new Date( this.filters.end);
        const dayDifference = (end - start) / (1000 * 60 * 60 * 24);
        if (dayDifference <= DateLimitForFilters) {
          this.updateItems()
        }
      }
    },
    onChangeFilterStartDisplayValue() {
      this.filters.start = null;
      this.updateItems()
    },
    onChangeFilterEndDisplayValue() {
      this.filters.end = null;
      this.updateItems()
    },
    onCreatePrintPackageClicked() {
      this.$v.$touch()

      if (!this.$v.$invalid) {
        this.createPrintPackage()
      }
    },
    onAddPostIndexClicked() {
      let vm = this;
      if (!vm.$v.filters.$invalid) {
        this.$store.dispatch(LAYOUT_LOADING_START)

        PostIndexService.massAddPostIndex({
          ids: vm.selectedItems.map((i) => i.id),
          region: vm.filters.region.id,
          area: vm.filters.area.id
        }).then(response => {
          vm.selectedItems = [];
          vm.allowSelectItems = false;

          this.showModal = true;

          this.$nextTick(() => {
            this.$refs.postIndexModal.set(response.data);
          });

          vm.updateItems();
        })
            .catch(error => {
              console.error(error);
            })
            .finally(() => {
              this.$store.dispatch(LAYOUT_LOADING_STOP);
            })
      }
    },
    updatePostIndex(index) {
      let vm = this;

      this.$store.dispatch(LAYOUT_LOADING_START);

      PostIndexService.updatePostIndex({
        id: vm.items[index].id,
        postIndex: vm.postIndex
      })
          .then(() => {
            vm.postIndex = '';
            vm.editingIndex = null;
            vm.updateItems();
          })
          .catch(error => console.log(error))
          .then(() => {
            this.$store.dispatch(LAYOUT_LOADING_STOP);
          });
    },
    toggleAllowSelectItems(event) {
      let vm = this;
      vm.$v.filters.$touch();
      vm.allowSelectItems = event;
      vm.itemsToggled = true
      if (!event)
        vm.$v.filters.$reset();
    },
    onEditPostIndex(index, item) {
      let vm = this;
      if (vm.allowOperations) {
        vm.editingIndex = index;
        vm.postIndex = item.postIndex && item.postIndex.postCode;
      }
    }
  },
  mounted() {
    if (this.$route.query) {

      // options
      //todo handle options from $route.query
      if (this.$route.query.sortBy) {
        this.options.sortBy = []
        const sortBy = this.$route.query.sortBy
        this.options.sortBy.push(sortBy)
      }
      if(this.$route.query.sortDesc) {
        this.options.sortDesc = []
        let val = converter.stringToBoolean(this.$route.query.sortDesc)
        this.options.sortDesc.push(val)
      }
      if(this.$route.query.page) {
        this.options.page = converter.stringToNumber(this.$route.query.page)
      }
      if(this.$route.query.itemsPerPage) {
        this.options.itemsPerPage = converter.stringToNumber(this.$route.query.itemsPerPage)
      }

      // filters
      if(this.$route.query.region) {
        this.filters.region = _.find(this.$store.getters.appLogin.regions, r => { return r.id === converter.stringToNumber(this.$route.query.region) })
      }
      if(this.$route.query.area) {
        this.filters.area = _.find(this.$store.getters.appLogin.areas, a => { return a.id === converter.stringToNumber(this.$route.query.area) })
      }
      if(this.$route.query.isDistributed) {
        this.filters.isDistributed = converter.stringToBoolean(this.$route.query.isDistributed)
      }
      if(this.$route.query.isPrinted) {
        this.filters.isPrinted = converter.stringToBoolean(this.$route.query.isPrinted)
      }
      if(this.$route.query.isPosted) {
        this.filters.isPosted = converter.stringToBoolean(this.$route.query.isPosted)
      }
      if(this.$route.query.isPerformed) {
        this.filters.isPerformed = converter.stringToBoolean(this.$route.query.isPerformed)
      }
      if(this.$route.query.isTransferNotified) {
        this.filters.isTransferNotified = converter.stringToBoolean(this.$route.query.isTransferNotified)
      }
      if(this.$route.query.isTransferCompleted) {
        this.filters.isTransferCompleted = converter.stringToBoolean(this.$route.query.isTransferCompleted)
      }
      if(this.$route.query.isExpress) {
        this.filters.isExpress = converter.stringToBoolean(this.$route.query.isExpress)
      }
      if(this.$route.query.start) {
        this.filters.start = this.$route.query.start
        this.filterStartDisplayValue = Moment(this.filters.start, 'YYYY-MM-DD').format('DD.MM.YYYY')
      }
      if(this.$route.query.end) {
        this.filters.end = this.$route.query.end
        this.filterEndDisplayValue = Moment(this.filters.end, 'YYYY-MM-DD').format('DD.MM.YYYY')
      }
      if(this.$route.query.postIndex) {
        this.filters.postIndex = _.find(this.$store.getters.appPostIndexes, r => { return r.id === converter.stringToNumber(this.$route.query.postIndex) })
      }
    }
  },
  created() {
    this.filters.start = Moment().subtract(14, "days").format('YYYY-MM-DD')
    this.filters.end = Moment().format('YYYY-MM-DD')
    this.filterStartDisplayValue = Moment(this.filters.start, 'YYYY-MM-DD').format('DD.MM.YYYY')
    this.filterEndDisplayValue = Moment(this.filters.end, 'YYYY-MM-DD').format('DD.MM.YYYY')
  },
  watch: {
    options: {
      handler() {
        this.updateItems()
      }
    },
  }
}
</script>

<style scoped>
.white--text a {
  color: #ffffff;
  text-decoration: none;
}
</style>
